
<div class="item-container nav-container"
    (mouseenter)="showtoolbar=true"
    (mouseleave)="showtoolbar=false"
>
    <img [src]="item.small" 
    matTooltip="{{imageDescriptionToolTip(item)}}" 
    alt="{{imageDescriptionToolTip(item)}}"
    width="128px" 
    [ngClass]="{ 'ngx-gallery-clickable': options.clickable }" >
    <div *ngIf="options.showLabels" class="ngx-gallery-label">{{item.label}}</div>
    <div class="selecteddiv" [ngClass]="{ 'ngx-gallery-active': idx == selectedIndex}"></div>
    <div class="toolbar" *ngIf="showtoolbar">
        <div class="ml-auto toolbar-buttons">
          <button type="button" class="btn btn-primary btn-sm"  (click)="show_click()" matTooltip="Show this image bounds on map"><i class="far fa-eye"></i></button>  
          <button type="button" class="btn btn-primary btn-sm"  (click)="addissue_click()" matTooltip="Add issue from selected image"><i class="far fa-window-close"></i></button>
          <button type="button" class="btn btn-primary btn-sm"  (click)="expandImage_click()"  matTooltip="Show selected image in high resolution"><i class="fas fa-expand-alt"></i></button>
        </div>
    </div> 
</div>

